import React, { useContext } from "react";
import RadioButtonContainer from "../../ui/layout/page/forms-container/form-item-container/radio-button-container/input-container";
import ChoosePerson from "../shared/components/choose-person";
import { RegulatoryInformationModel } from "./types";
import { AdminContext } from "./adminContext";
import { Persons } from "./controlling-owner-persons";

interface ControllingOwnerProps {
  isOwnerSameAsAdmin: RegulatoryInformationModel["isOwnerSameAsAdmin"];
  controllingOwners: RegulatoryInformationModel["controllingOwners"];
  maxOwnersAllowed: number;
  legendText?: string;
}

export const ControllingOwners: React.FC<ControllingOwnerProps> = ({
  isOwnerSameAsAdmin,
  controllingOwners,
  maxOwnersAllowed,
  legendText,
}: ControllingOwnerProps) => {
  const { admin } = useContext(AdminContext);

  return (
    <>
      <RadioButtonContainer>
        <ChoosePerson
          title={legendText}
          id="isOwnerSameAsAdmin"
          name="isOwnerSameAsAdmin"
          values={[
            {
              id: "owner-same-as-admin-yes",
              value: "yes",
              messageKey: "ControllingOwner.SAME_AS_CONTACT",
              person: admin,
            },
            {
              id: "owner-same-as-admin-no",
              value: "no",
              messageKey: "ControllingOwner.OTHER",
            },
          ]}
        />
      </RadioButtonContainer>
      {isOwnerSameAsAdmin === "yes" && (
        <Persons
          name="controllingOwners.admin"
          formData={controllingOwners.admin}
          limit={maxOwnersAllowed}
        />
      )}
      {isOwnerSameAsAdmin === "no" && (
        <Persons
          name="controllingOwners.other"
          formData={controllingOwners.other}
          limit={maxOwnersAllowed}
        />
      )}
    </>
  );
};
